import { CatalogTypePage } from './CatalogTypePage';
import { CatalogCountertopFormPage } from './CatalogCountertopFormPage';

const SHARED = {
  type: 'COUNTERTOP' as const,
  i18nNs: 'countertops',
  listTo: '/countertops' as const,
  newTo: '/countertops/new' as const,
  editToParent: '/countertops/$id' as const,
};

export function CountertopsListPage() {
  return (
    <CatalogTypePage
      type={SHARED.type}
      i18nNs={SHARED.i18nNs}
      listTo={SHARED.listTo}
      newTo={SHARED.newTo}
      editToParent={SHARED.editToParent}
    />
  );
}

export function CountertopCreatePage() {
  return <CatalogCountertopFormPage mode="create" />;
}

export function CountertopEditPage() {
  return <CatalogCountertopFormPage mode="edit" />;
}
